import './reason.styles.scss';

import React, { useState, useContext, useEffect } from "react";
import { Grid, Box} from "@mui/material";
import RadioGroup from '@mui/material/RadioGroup';
import InputRadio from "../../../components/input-radio/input-radio.component";
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from "../../../components/button/button.component";
import { Link, useNavigate} from "react-router-dom";
import InputText from "../../../components/input-text/input-text.component";
import { CancelContext } from '../../../contexts/cancellation.context';
import { addError, freshDeskReport, removeErrorConfirm} from '../../../utils/generaFunctions';
import { cancelSubscription, updateBoxSeq } from '../../../utils/recurly.functions';

const Reason = (props) => {
    const {userInfo, cancelInfo, changeCancelInfo, setLoading} = useContext(CancelContext);
    const navigate = useNavigate();
    const [choice, setChoice] = useState(-1);
    const [category, setCategory] = useState("");
    const [otherText, setOtherText] = useState("");
    const [valid, setValid] = useState(false);
    const options = [ 
            {value: "fin_cat", text:"Financial"},
                {tag:"Can't Afford Anymore", value:"price_sub", text: "I love it, but I can't afford it anymore", parent:"fin_cat"},
                {tag:"Not worth the price", value:"worth_sub", text: "Not worth the price", parent:"fin_cat"},
            {tag:"Health-Related", value: "health", text:"Health-Related Circumstances"},
            {value: "prod_cat", text:"Don't like the boxes / Issues with the products"},
                {tag:"Poor Quality", value:"poor_sub", text: "Poor quality products", parent:"prod_cat"},
                {tag:"Style/Design", value:"design_sub", text: "I don't like the style/design", parent:"prod_cat"},
                {tag:"Not Useful", value:"useful_sub", text: "Product aren't useful", parent:"prod_cat"},
            {tag:"Other", value:"other", text: "Other / Write your own", parent:""},
        ];
    function handleChange(e){
        if(String(e.target.value).indexOf("_sub")>0){
            setChoice(e.target.value);
            setOtherText("");
            setValid(true);
        } else if (String(e.target.value).indexOf("_cat")>0){
            setCategory(e.target.value);
            setChoice(e.target.value);
            setOtherText("");
            setValid(false);
        }else if(e.target.value === "other") {
            setChoice(e.target.value);
            setCategory("");
            setValid(true);
        } else {
            setChoice(e.target.value);
            setCategory("");
            setValid(true);
        }
    }

    useEffect(()=>{
        changeCancelInfo({choice:""});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(()=>{
        changeCancelInfo({...options.find((option)=>option.value===choice), category:category, otherText:otherText});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [otherText, choice, category])

    useEffect(()=>{
        if(valid) removeErrorConfirm();
    },[valid])
    
    return(
        <div className="cancel-continue-container">
            <Grid container item className='flex-vertical' xs={12}>
            <Grid item className='title' xs={12}>
                <h1>We’re sad to see you go</h1>
            </Grid>
            <Grid item className='desc' xs={12}>Your response will help us improve the experience for other moms-to-be.</Grid>
            <Box id="reason-container">
            <Grid item className='small-header' xs={12}>Choose a reason:</Grid>
                    <RadioGroup name="reason" value={choice} onChange={(e)=>handleChange(e)}>
                        {options.map((option, index)=>{
                            return <div style={{display:!option.parent || category===option.parent?"":"none"}}>
                                        <FormControlLabel 
                                            key={`reason_option${index}`} 
                                            className={option.parent?"sub-reason":""} 
                                            value={option.value} 
                                            control={<InputRadio sub={option.parent?"yes":""}/>} 
                                            label={option.text}>
                                        </FormControlLabel>
                                    </div>
                                    
                                    
                        })}
                        <div style={{ display: choice==="other"?"":"none"}}>
                            <InputText multiline rows={5} value={otherText} onChange={(e) => { setOtherText(e.target.value) }} />
                        </div>
                    </RadioGroup>
            </Box>
            <Grid item id='button-container'>
                <Link 
                    className={`button-link`} 
                    onClick={()=>{
                        
                        if(!valid){
                            addError(document.getElementById('reason-container'), 'Select one of the options above first and then click continue');
                        } else if(cancelInfo.value==="official_sub"){
                            setLoading(true);
                            updateBoxSeq(userInfo.email, "15").then((response)=>{
                                freshDeskReport(userInfo.email, userInfo.name, "Prevented From: "+ cancelInfo.text + (cancelInfo.otherText?", "+cancelInfo.otherText:""), "SysT1.0: Keep Subscription", "SysT1.0: Keep Subscription", "SysT1.0: It's Official box").then((data)=>{
                                    navigate("../canceled"+window.location.search);
                                })
                              }).catch(()=>{
                                navigate("../canceled"+window.location.search);
                            })
                        } else {
                            setLoading(true);
                            cancelSubscription(userInfo.email, true).then((resultJSON)=>{
                                freshDeskReport(userInfo.email, userInfo.name, "Canceled: "+cancelInfo.tag+ (cancelInfo.otherText?", "+cancelInfo.otherText:""), "SysT1.0: Canceled","SysT1.0: Canceled", "SysT1.0: " + cancelInfo.tag).then((data)=>{
                                    navigate("../canceled"+window.location.search);
                                })
                            }).catch(()=>{
                                navigate("../canceled"+window.location.search);
                            })
                        }
                    }}
                ><Button text="confirm"></Button></Link>
                <Link className={`button-link`} to={"../keep"+window.location.search}><Button className="btn-reverse" text={"Keep my subscription as-is"}/></Link>
            </Grid>
            <Link className='go-back' to={'../'+window.location.search}>&lt;&lt; BACK TO PREVIOUS PAGE</Link>
            </Grid>
        </div>
        )
}

export default Reason;